import React, { useEffect, useCallback } from 'react';
import axios from 'axios';
import url from '../../../constants/config';

import './WhatsNew.scss';

/**
 * Bump this version string whenever you want to show the modal again
 * to all users. Format: YYYY-MM (or YYYY-MM-DD for more granularity).
 */
export const CHANGELOG_VERSION = '2026-03-coach-messaging';

const changes = [
  {
    icon: '💬',
    title: 'Coach-Player Messaging Is Now In-App',
    desc: 'From now on, communication with players happens inside PlaySportUSA instead of external channels.',
  },
  {
    icon: '📨',
    title: 'Start From "Contact this Player"',
    desc: 'On a player profile, click "Contact this Player" as before. Your first message opens the conversation thread automatically.',
  },
  {
    icon: '📥',
    title: 'Continue In Messages',
    desc: 'After sending, the conversation is available in your Messages inbox, where you can continue the thread anytime.',
  },
  {
    icon: '🔔',
    title: 'Reply Notifications Included',
    desc: 'You receive in-app notifications for new replies, and email notifications are also sent when someone responds.',
  },
];

const WhatsNew = ({ user, onDismiss }) => {
  const dismiss = useCallback(() => {
    // Fire-and-forget API call to mark as seen
    const token = window.localStorage.getItem('authorization');
    if (token && user?.universityEmail) {
      axios
        .put(
          `${url}/users/changelog-seen`,
          { version: CHANGELOG_VERSION },
          { headers: { Authorization: `Bearer ${token}` } }
        )
        .catch(() => {});
    }
    onDismiss();
  }, [user, onDismiss]);

  // Close on Escape key
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') dismiss();
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [dismiss]);

  // Block body scroll
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  return (
    <div className="whats-new__overlay" onMouseDown={dismiss}>
      <div
        className="whats-new__modal"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="whats-new__close"
          onClick={dismiss}
          aria-label="Close"
        >
          <i className="fas fa-times" />
        </button>

        <div className="whats-new__header">
          <span className="whats-new__badge">NEW</span>
          <h2 className="whats-new__title">Messaging Update for Coaches</h2>
          <p className="whats-new__subtitle">
            We have updated how coach-player communication works. Here is what changed.
          </p>
        </div>

        <div className="whats-new__list">
          {changes.map((item, i) => (
            <div key={i} className="whats-new__item">
              <span className="whats-new__item-icon" role="img" aria-label={item.title}>{item.icon}</span>
              <div>
                <h4 className="whats-new__item-title">{item.title}</h4>
                <p className="whats-new__item-desc">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="whats-new__footer">
          <button
            type="button"
            className="whats-new__btn"
            onClick={dismiss}
          >
            Got it, let's go!
          </button>
        </div>
      </div>
    </div>
  );
};

export default WhatsNew;
